import { markRaw, type Component } from 'vue';
import { Capacitor } from '@capacitor/core';
import { RouteNames } from '@/acl/permissions';
import { IconMenuPos, IconMenuCrm, MenuBooking, IconMenuProduct, IconMenuSettings, IconMenuAnalytics, IconMenuReporting } from '@xpos/icons-svg';
import type { getPlatform } from '@/utils/misc';

export type MenuItem = { icon: Component; path: string; name: string; permission?: string };

// Static menu config - built once at module load, shared across all Menu.vue mount points
export const baseMenus: MenuItem[] = [
    { icon: markRaw(IconMenuPos), path: '/pos', name: 'menu.pos', permission: RouteNames.POS },
    { icon: markRaw(IconMenuCrm), path: '/crm', name: 'menu.crm' },
    { icon: markRaw(MenuBooking), path: '/booking', name: 'menu.booking', permission: RouteNames.BOOKING },
    { icon: markRaw(IconMenuProduct), path: '/management', name: 'menu.management', permission: RouteNames.MANAGEMENT },
    { icon: markRaw(IconMenuSettings), path: '/settings', name: 'menu.settings', permission: RouteNames.SETTINGS },
    { icon: markRaw(IconMenuAnalytics), path: '/analytics', name: 'menu.analytics' },
    ...(!Capacitor.isNativePlatform() ? [{ icon: markRaw(IconMenuReporting), path: '/reporting', name: 'menu.reporting' }] : []),
];

export function filterMenusForPlatform(platform: ReturnType<typeof getPlatform>, appointmentEnabled: boolean): MenuItem[] {
    let result = baseMenus;
    if (platform === 'desktop-web') result = baseMenus.filter(m => !['/pos'].includes(m.path));
    else if (platform === 'mobile-web') result = baseMenus.filter(m => !['/pos', '/crm', '/management', '/settings', '/booking'].includes(m.path));
    return appointmentEnabled ? result : result.filter(m => m.path !== '/booking');
}
